import { useState } from "react";
import { Link } from "react-router-dom";

interface VideoPlayerProps {
  cover: string;
  title: string;
  duration: string;
}

type PlayerStatus = "idle" | "loading" | "error";

export default function VideoPlayer({ cover, title, duration }: VideoPlayerProps) {
  const [status, setStatus] = useState<PlayerStatus>("idle");

  const handlePlay = () => {
    if (status === "loading") return;
    setStatus("loading");
    window.setTimeout(() => setStatus("error"), 1600);
  };

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-foreground-950">
      <img
        src={cover}
        alt={title}
        title={`${title} - 西瓜视频`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/55"></div>

      {status === "idle" && (
        <button
          type="button"
          onClick={handlePlay}
          aria-label="播放视频"
          className="absolute inset-0 flex flex-col items-center justify-center gap-4 cursor-pointer group"
        >
          <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500 group-hover:bg-primary-600 flex items-center justify-center transition-colors">
            <i className="ri-play-fill text-background-50 text-3xl md:text-4xl w-8 h-8 flex items-center justify-center"></i>
          </span>
          <span className="text-background-100 text-sm">点击播放（演示模式）</span>
          <span className="absolute bottom-4 right-4 px-1.5 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">
            时长 {duration}
          </span>
        </button>
      )}

      {status === "loading" && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
          <span className="w-10 h-10 rounded-full border-2 border-background-200/40 border-t-primary-500 animate-spin"></span>
          <p className="text-background-100 text-sm">正在加载视频…</p>
        </div>
      )}

      {status === "error" && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
          <span className="w-14 h-14 rounded-full bg-foreground-950/60 flex items-center justify-center">
            <i className="ri-error-warning-line text-3xl text-primary-400"></i>
          </span>
          <h2 className="text-background-50 text-lg font-bold">视频暂时无法播放</h2>
          <p className="text-background-200 text-sm max-w-md">
            当前为演示模式，本站未接入真实视频流接口，因此无法播放实际内容。
          </p>
          <div className="flex items-center gap-3 mt-1">
            <button
              type="button"
              onClick={handlePlay}
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-refresh-line"></i>
              重试
            </button>
            <Link
              to="/"
              className="inline-flex items-center gap-1 px-4 py-2 rounded-md border border-background-200/50 text-background-100 text-sm font-medium hover:bg-foreground-950/40 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}